export default __webpack_public_path__ + "6d46a97b5a1ef9599d3cdf24372f4a26.png";